// ═══════════════════════════════════════════════════════════════════════════════
// Notification validation schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
export const notificationListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export const notificationIdParamSchema = z.object({
    id: z.string().uuid('Invalid notification id'),
});
export const pushSubscriptionSchema = z.object({
    endpoint: z.url('Invalid push endpoint'),
    keys: z.object({
        p256dh: z.string().min(1, 'Missing p256dh key'),
        auth: z.string().min(1, 'Missing auth key'),
    }),
});
export const pushSubscribeBodySchema = z.object({
    subscription: pushSubscriptionSchema,
});
export const pushUnsubscribeBodySchema = z.object({
    endpoint: z.string().url('Invalid endpoint'),
});
//# sourceMappingURL=notification.schema.js.map